// @flow

import * as UserNotification from 'app/entities/UserNotification';
import { hasUnreadImportantNotifications } from 'app/viewport/utils/notification';

type ViewportState = {
  isNotificationsDropdownOpen?: boolean,
};

export const isNotificationsDropdownOpen = (state: {
  viewport: ViewportState,
}) =>
  state.viewport.isNotificationsDropdownOpen ||
  hasUnreadImportantNotifications(
    UserNotification.selectors.all
      .notDismissed(state)
      .map(entity => UserNotification.selectors.data(entity))
  );

export const shouldHeldTasksBannerBeVisible = (currentPathname: string) => {
  const allowedRoutes = [
    /app\/connections/,
    /app\/dashboard/,
    /app\/history/,
    /app\/zaps/,
  ];

  return allowedRoutes.some(regex => regex.test(currentPathname));
};
